import { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';
import info from '../../../assets/icons/info-circle-solid.svg';
import useDropdown from '../../../hooks/useDropdown';
import { T } from 'Helpers';

interface TooltipProps {
	optionDescription?: string;
	$isMobile?: boolean;
}

const TooltipContainer = styled.div`
	position: absolute;
	right: 5px;
	top: 5px;
	z-index: 3;
	text-align: center;
`;

const InfoIcon = styled.img<{ $isMobile?: boolean }>`
	height: 22px;
	width: 22px;
`;

const OptionTooltipContent = styled.div`
	max-width: 200px;
	padding: 5px;
`;

const TOOLTIP_DISMISS_EVENT = 'tooltip-dismiss-others';

const Tooltip: FC<TooltipProps> = ({ optionDescription: text, $isMobile: isMobile }) => {
	const [open, close, isOpened, Dropdown] = useDropdown();
	const ref = useRef<HTMLImageElement>(null);
	const tooltipId = useRef(Math.random().toString(36));
	const closeRef = useRef(close);
	closeRef.current = close;

	useEffect(() => {
		const handler = (e: Event) => {
			if ((e as CustomEvent).detail !== tooltipId.current) {
				closeRef.current();
			}
		};
		document.addEventListener(TOOLTIP_DISMISS_EVENT, handler);
		return () => document.removeEventListener(TOOLTIP_DISMISS_EVENT, handler);
	}, []);

	return (
		<TooltipContainer>
			{isMobile ? (
				<InfoIcon
					ref={ref}
					$isMobile={isMobile}
					onClick={(e) => {
						e.stopPropagation();
						document.dispatchEvent(new CustomEvent(TOOLTIP_DISMISS_EVENT, { detail: tooltipId.current }));
						open(ref.current!, 'top', 'left', true);
					}}
					src={info}
				/>
			) : (
				<InfoIcon
					ref={ref}
					$isMobile={isMobile}
					onMouseEnter={() => open(ref.current!, 'top', 'right', true)}
					onMouseLeave={() => close()}
					src={info}
				/>
			)}

			{isOpened && text && (
				<Dropdown>
					<OptionTooltipContent>{T._d(text)}</OptionTooltipContent>
				</Dropdown>
			)}
		</TooltipContainer>
	);
};

export default Tooltip;
